import React from "react";
import PropTypes from "prop-types";
import SummaryItem from "../components/SummaryItem.jsx";
import SectionItem from "../components/SectionItem.jsx";
import { ServiceLink } from "../components/ServiceLink.jsx";
import AudioFile from "../components/AudioFile.jsx";
import { Voicemail } from "../components/Voicemail.jsx";
import * as CONST from "../constants";
import DestinationGroup from "../components/DestinationGroup.jsx";

const CallerException = (props) => {
  const { module } = props;
  return (
    <SummaryItem itemKey={"Caller Exception: "}>
      <SectionItem itemKey={"Group Name"}>{module.name}</SectionItem>
      <SectionItem itemKey={"CLI"}>
        {module.callerExceptionCliList.map((cli, idx) => (
          <div key={idx}>{cli.cli}</div>
        ))}
      </SectionItem>
      <SectionItem itemKey="Divert Calls to">
        {CONST.CallerExceptionAction[module.callerExceptionAction]}
      </SectionItem>
      {module.callerExceptionAction === 1 && (
        <SectionItem itemKey="Divert Destination">
          <DestinationGroup
            group={module}
            sites={props.sites}
            clientId={props.clientId}
          />
        </SectionItem>
      )}
      {module.callerExceptionAction === 2 && (
        <SectionItem itemKey="Divert Audio">
          <AudioFile audioId={module.audio} />
        </SectionItem>
      )}
      {module.callerExceptionAction === 5 && (
        <SectionItem itemKey="Divert Service">
          <ServiceLink service={module.moduleGroupOption} />
        </SectionItem>
      )}
      {module.callerExceptionAction === 8 && (
        <Voicemail config={module.voicemail} />
      )}
    </SummaryItem>
  );
};

export default CallerException;

CallerException.propTypes = {
  module: PropTypes.object,
  sites: PropTypes.array,
  clientId: PropTypes.any,
};
